import classNames from 'classnames'
import { motion } from 'framer-motion'
import { memo, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { Icon, IconNameType } from '@ds'
import { useScrollDirection } from '@shared'
import { useNavbarActions } from '@store'

import styles from './Navbar.module.scss'

const navMenu = [
  {
    title: 'Home',
    slug: 'home',
    link: '/',
    icon: 'gate',
  },
  {
    title: 'StarLog',
    slug: 'starLog',
    link: '/battle-pass',
    icon: 'diamond',
  },
  {
    title: 'Profile',
    slug: 'profile',
    link: '/profile',
    icon: 'eye',
  },
  {
    title: 'LeaderBoard',
    slug: 'leaderboard',
    link: '/leaderboard',
    icon: 'stars',
  },
]

function isActive(path: string, slug?: string) {
  if (path === '/home' && slug === 'home') {
    return true
  }

  if (path === '/battle-pass' && slug === 'starLog') {
    return true
  }

  if (['/profile', '/settings', '/friends'].includes(path) && slug === 'profile') {
    return true
  }

  if (path === '/leaderboard' && slug === 'leaderboard') {
    return true
  }
  // return ['/collections'].includes(path)
}

type Props = {
  isFadeble?: boolean
  scrollContainerRef?: React.RefObject<HTMLDivElement | null>
}

export const Navbar = memo(function Navbar({
  isFadeble,
  scrollContainerRef,
}: Props) {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  const { scrollDirection } = useScrollDirection({
    threshold: 5,
    containerRef: scrollContainerRef,
  })

  const { setNavbarVisible } = useNavbarActions()

  const shouldHide = isFadeble && scrollDirection === 'down'

  useEffect(() => {
    setNavbarVisible(!shouldHide)
  }, [shouldHide])

  const navbarVariants = {
    visible: {
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 30,
      },
    },
    hidden: {
      opacity: 0,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 30,
      },
    },
  }

  return (
    <motion.div
      id="main-navbar"
      className={classNames(styles.navbar, {
        [styles.isFadeble]: isFadeble,
        [styles.isHidden]: shouldHide,
      })}
      initial="visible"
      animate={shouldHide ? 'hidden' : 'visible'}
      variants={navbarVariants}
    >
      {navMenu.map((item) => (
        <div
          className={classNames(
            styles.navbarItem,
            isActive(location.pathname, item.slug) && styles.isActive
          )}
          onClick={() => navigate(item.link)}
          key={item.title}
        >
          <div className={styles.navbarIcon}>
            <Icon name={item.icon as IconNameType} />
          </div>
          <div className={styles.navbarItemTitle}>
            {t(`navbar.${item.slug}`)}
          </div>
        </div>
      ))}
    </motion.div>
  )
})
